import { gql } from "@apollo/client";

const schema = {
  reject: {
    name: "rejectRequest",
    serviceName: "auth",
    query: gql`
      mutation rejectRequest($id: String!, $details: String) {
        rejectRequest(id: $id, details: $details) {
          messages
        }
      }
    `,
  },
};

export default schema;
